<template>
  <div class="news">
    <div class="banner">
      <div class="font-weight-bold">
        News
      </div>
    </div>
    <div class="list">

      <a class="item" href="https://www.prnewswire.com/news-releases/gv20-therapeutics-announces-achievement-of-milestone-under-antibody-drug-conjugate-collaboration-with-mitsubishi-tanabe-pharma-corporation-302625157.html">
        <cite class="title">GV20 Therapeutics Announces Achievement of Milestone under Antibody-Drug Conjugate Collaboration with Mitsubishi Tanabe Pharma Corporation</cite>
        <span class="date">Nov 25, 2025</span>
      </a>

      <a class="item" href="/news-details/20250602">
        <cite class="title">GV20 Therapeutics Presents Updated Phase 1 Monotherapy Data on GV20-0251 at the ASCO Annual Meeting 2025</cite>
        <span class="date">Jun 2, 2025</span>
      </a>

      <a class="item" href="/news-details/20250523">
        <cite class="title">GV20 Therapeutics to Present Updated Phase 1 Monotherapy Data on GV20-0251 at the ASCO Annual Meeting 2025</cite>
        <span class="date">May 23, 2025</span>
      </a>

      <a class="item" href="/news-details/20250429">
        <cite class="title">GV20 Therapeutics Presents Cancer-Extrinsic Mechanism of Action Data on GV20-0251 at the AACR Annual Meeting 2025</cite>
        <span class="date">Apr 29, 2025</span>
      </a>

      <a class="item" href="https://www.prnewswire.com/news-releases/gv20-therapeutics-announces-collaboration-agreement-with-mitsubishi-tanabe-pharma-corporation-to-develop-novel-antibody-drug-conjugates-302411169.html">
        <cite class="title">GV20 Therapeutics Announces Collaboration Agreement with Mitsubishi Tanabe Pharma Corporation to Develop Novel Antibody-Drug Conjugates</cite>
        <span class="date">Mar 26, 2025</span>
      </a>

      <a class="item" href="https://www.prnewswire.com/news-releases/gv20-therapeutics-presents-promising-phase-1-monotherapy-data-on-novel-checkpoint-inhibitor-gv20-0251-at-esmo-congress-2024-302247149.html">
        <cite class="title">GV20 Therapeutics Presents Promising Phase 1 Monotherapy Data on Novel Checkpoint Inhibitor GV20-0251 at ESMO Congress 2024</cite>
        <span class="date">Sept 16, 2024</span>
      </a>

      <a class="item" href="https://www.prnewswire.com/news-releases/gv20-therapeutics-to-present-clinical-data-on-gv20-0251-at-the-esmo-congress-2024-302225841.html">
        <cite class="title">GV20 Therapeutics to Present Clinical Data on GV20-0251 at the ESMO Congress 2024</cite>
        <span class="date">Aug 21, 2024</span>
      </a>

      <a class="item" href="https://www.linkedin.com/posts/gv20tx_oncology-biotech-ai-activity-7201613010379948033-Pim2/">
        <cite class="title">Flavian D. Brown, Our Principal Scientist, was Selected for the Posse Alumni Category</cite>
        <span class="date">May 31, 2024</span>
      </a>

      <a class="item" href="https://www.prnewswire.com/news-releases/gv20-therapeutics-to-present-at-the-jefferies-healthcare-conference-private-biotech-day-302152897.html">
        <cite class="title">GV20 Therapeutics to Present at the Jefferies Healthcare Conference Private Biotech Day</cite>
        <span class="date">May 22, 2024</span>
      </a>

      <a class="item" href="//gv20tx.com/media/news/BioCentury_ScienceSpotlight_2024-05-04.pdf">
        <cite class="title">Science spotlight: Biotechs discover new checkpoint target, and more</cite>
        <span class="date">May 4, 2024</span>
      </a>

      <a class="item" href="https://www.prnewswire.com/news-releases/gv20-therapeutics-announces-publication-in-cell-highlighting-the-discovery-of-igsf8-as-an-innate-immune-checkpoint-and-cancer-immunotherapy-target-302126064.html">
        <cite class="title">GV20 Therapeutics Announces Publication in Cell Highlighting the Discovery of IGSF8 as an Innate Immune Checkpoint and Cancer Immunotherapy Target</cite>
        <span class="date">Apr 24, 2024</span>
      </a>

      <a class="item" href="https://www.prnewswire.com/news-releases/gv20-therapeutics-announces-clinical-trial-collaboration-to-evaluate-gv20-0251-a-first-in-class-antagonist-antibody-against-the-novel-immune-checkpoint-igsf8-in-combination-with-keytruda-pembrolizumab-302120896.html">
        <cite class="title">GV20 Therapeutics Announces Clinical Trial Collaboration to Evaluate GV20-0251, a First-in-Class Antagonist Antibody Against the Novel Immune Checkpoint IGSF8, in Combination with KEYTRUDA® (pembrolizumab)</cite>
        <span class="date">Apr 18, 2024</span>
      </a>

      <router-link class="item" :to="{name:'newsDetails15'}">
        <cite class="title">GV20 Therapeutics Presents Preclinical Data on GV20-0251 for Solid Tumors Targeting IGSF8 at AACR Annual Meeting 2024</cite>
        <span class="date">Apr 8, 2024</span>
      </router-link>

      <router-link class="item" :to="{name:'newsDetails14'}">
        <cite class="title">GV20 Therapeutics to Present at the Needham 23rd Annual Virtual Healthcare Conference</cite>
        <span class="date">Apr 2, 2024</span>
      </router-link>

      <router-link class="item" :to="{name:'newsDetails13'}">
        <cite class="title">GV20 Therapeutics Joins NVIDIA Inception to Develop AI Models for Drug and Target Discovery</cite>
        <span class="date">Mar 12, 2024</span>
      </router-link>

      <router-link class="item" :to="{name:'newsDetails12'}">
        <cite class="title">GV20 Therapeutics Announces Oral Presentation on GV20-0251 for Solid Tumors Targeting IGSF8 at AACR Annual Meeting 2024</cite>
        <span class="date">Mar 5, 2024</span>
      </router-link>

      <router-link class="item" :to="{name:'newsDetails11'}">
        <cite class="title">GV20 Therapeutics Appoints Christopher K. Mirabelli, Ph.D. to Board of Directors</cite>
        <span class="date">Jan 9, 2024</span>
      </router-link>

      <router-link class="item" :to="{name:'newsDetails10'}">
        <cite class="title">GV20 Therapeutics to Present Preclinical Data on GV20-0251 at ESMO Congress 2023</cite>
        <span class="date">Oct 17, 2023</span>
      </router-link>

      <router-link class="item" :to="{name:'newsDetails9'}">
        <cite class="title">GV20 Therapeutics Strengthens Immuno-Oncology Expertise with Two New Advisors</cite>
        <span class="date">Oct 3, 2023</span>
      </router-link>

      <router-link class="item" :to="{name:'newsDetails8'}">
        <cite class="title">GV20 Therapeutics Expands Leadership Team with Appointments of Three Key Executives</cite>
        <span class="date">Mar 28, 2023</span>
      </router-link>

      <router-link class="item" :to="{name:'newsDetails5'}">
        <cite class="title">GV20 Therapeutics Announces First Patient Dosed in Phase 1 Clinical Trial of GV20-0251 in Patients with Advanced Solid Tumors</cite>
        <span class="date">Mar 24, 2023</span>
      </router-link>

      <a class="item" href="https://www.businesswire.com/news/home/20220720005122/en/GV20-Therapeutics-Announces-Appointment-of-Three-Advisers">
        <cite class="title">GV20 Therapeutics Announces Appointment of Three Advisers</cite>
        <span class="date">Jul 20, 2022</span>
      </a>

      <a class="item" href="https://www.businesswire.com/news/home/20220629005228/en/GV20-Therapeutics-Builds-Experienced-Leadership-Team-with-Appointments-of-Three-Key-Executives">
        <cite class="title">GV20 Therapeutics Builds Experienced Leadership Team with Appointments of Three Key Executives</cite>
        <span class="date">Jun 29, 2022</span>
      </a>

      <a class="item" href="https://doi.org/10.1016/j.immuni.2022.02.009">
        <cite class="title">GV20 Publication on the Maturation and Function of Intra-tumoral Antibodies</cite>
        <span class="date">Mar 14, 2022</span>
        <!-- <img class="picture" src="./assets/img-news-20220314.jpg" alt=""> -->
      </a>

      <router-link class="item" :to="{name:'newsDetails4'}">
        <cite class="title">Dr. Shirley Liu of GV20 Therapeutics is inducted into the AIMBE College of Fellows</cite>
        <span class="date">Feb 25, 2022</span>
        <!-- <img class="picture" src="./assets/img-new-1.jpg" alt=""> -->
      </router-link>

      <router-link class="item" :to="{name:'newsDetails1'}">
        <cite class="title">GV20 Therapeutics Completes Series B Financing to Advance Pipeline into the Clinic and Expand Immuno-Oncology Drug Discovery Platform</cite>
        <span class="date">Oct 14, 2021</span>
        <!-- <img class="picture" src="./assets/img-new-1.jpg" alt=""> -->
      </router-link>

    </div>
    <Footers />
  </div>
</template>
<script>
import Footers from '@/components/Footers'
export default {
  data () {
    return {
    }
  },
  components: {
    Footers,
  }
}
</script>
<style lang="scss" scope>
.news {
  a {
    color: #000;
    &:hover {
      text-decoration: none;
    }
  }
  .banner {
    color: #fff;
    height: 256px;
    background: url(../assets/news/headline_bg.jpg) no-repeat center
      center/cover;
    font-size: 60px;
    display: flex;
    align-items: center;
    padding-left: 40px;
  }
  .list
  {
    margin: 80px 40px;
    border-top: 1px solid #979797;
    border-bottom: 1px solid #979797;
    .item
    {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 40px 0px;
      border-top: 1px solid #979797;
      &:first-child
      {
        border-top: none;
      }
      .date
      {
        margin-top: 20px;
        height: 60px;
        font-size: 32px;
        font-weight: bold;
        color: #6D7278;
        line-height: 60px;
      }
      .title
      {
        font-size: 40px;
        color: #2C2E30;
        line-height: 56px;
        font-style: normal;
      }
      .picture
      {
        width: 235px;
        height: 180px;
      }
    }
  }
}
</style>
